import React from 'react';
import { Navigate } from 'react-router-dom';
import { ensureAuthenticated } from '../services/authGuardService';

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const guard = ensureAuthenticated();

    if (!guard.allowed) {
        return <Navigate to={guard.redirectTo} replace />;
    }

    return children;
};

export default ProtectedRoute;
